<mat-icon-button class="toggle-button" [matMenuTriggerFor]="menu" [class.active]="selectedFilters.length" (click)="onToggleButtonClick()">
  <span class="icon-Filter"></span>
</mat-icon-button>
<mat-menu #menu="matMenu">
  <div class="table-filter-menu" [class.width-bigger]="mode() === TABLE_MODE.SERVER">
    <div class="table-filter-menu-content" [id]="'filter-menu-' + selector()">
      @if (filterType() === 'search' && mode() === TABLE_MODE.SERVER && isFormVisible) {
        <form class="form-field" (click)="$event.stopPropagation()">
          <app-universal-dropdown
            [options]="filterSearchOptions"
            [displayFn]="displayFunctionFilters"
            [valueFn]="valueFunctionFilters"
            [isLoading]="isFilterValuesLoading"
            [isColumnFilterSearch]="true"
            [formControl]="selectedFiltersFormControl"
            [multiple]="true"
            [hasSearchBar]="true"
            [selectAllOption]="true"
            [placeholder]="
              isFilterValuesLoading() ? ('default.tableFiltersLoading' | translate) + '...' : ('default.search' | translate) + '...'
            "
          ></app-universal-dropdown>
          <div class="table-filter-menu-actions">
            <button class="btn btn-primary" (click)="applyFilters()">
              {{ 'default.apply' | translate }}
            </button>
          </div>
        </form>
      }

      @if (filterType() === 'search' && mode() === TABLE_MODE.CLIENT) {
        <form class="form-field" (click)="$event.stopPropagation()">
          <app-universal-dropdown
            [options]="filterSearchOptions"
            [formControl]="selectedFiltersFormControl"
            [multiple]="true"
            [hasSearchBar]="true"
            [selectAllOption]="true"
            [placeholder]="('default.search' | translate) + '...'"
          ></app-universal-dropdown>
        </form>
      }

      @if (filterType() === 'checkbox') {
        @if (!isFilterValuesLoading()) {
          <form (click)="$event.stopPropagation()">
            <div class="table-filter-menu-row">
              <mat-checkbox [checked]="isSaveAllSelected()" (change)="toggleSelectAll($event)">
                <span class="table-filter-menu-label">{{ 'default.selectAll' | translate }}</span>
              </mat-checkbox>
            </div>
            @for (filterOption of _filterOptions; track filterOption) {
              <div class="table-filter-menu-row">
                <mat-checkbox [checked]="isSelected(filterOption.value)" (change)="toggleFilter(filterOption.value)">
                  <span class="table-filter-menu-label">{{ filterOption.label | translate }}</span>
                </mat-checkbox>
              </div>
            }
            @if (mode() === TABLE_MODE.SERVER) {
              <div class="table-filter-menu-actions">
                <button class="btn btn-primary" (click)="applyFilters()">
                  {{ 'default.apply' | translate }}
                </button>
              </div>
            }
          </form>
        } @else {
          <app-loading [loadingMode]="LoadingMode.OVERLAY"></app-loading>
        }
      }
    </div>
  </div>
</mat-menu>
